// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__12V-0"};